import React from 'react'
import { useState } from 'react';
import america from "../../Assets/america.png";
import asia_pacific from "../../Assets/asia-pacific.png";
import middle_east from "../../Assets/middle-east-turkey-and-africa.png";
const ListOfAdresses = () => {

  const [activeLink, setActiveLink] = useState("america");
  console.log("activelink", activeLink);
  const handleNavLinkClick = (link) => {
    setActiveLink(link);
  };
      const officeaddressesamerica = [
        {
          country: "United States",
          company: "KCS Technologies Inc",
          address: `1603 Capitol Ave. Suite #310,Cheyenne,`,
          pincode: "Wyoming - 820010",
          email: "info@kcs-tech.com",
        },
        
      ];
    
    const officeaddressesasiapacific = [
      {
          country: "Indonesia",
          company: "PT KCS Technologies Indonesia",
          address: `BSD Green Office Park 1, 6th Floor Jl.
           BSD Green Office Park, BSD City,`,
          pincode: "Tangerang - 15345",
          email: "info@ptkcs.com",
        },
        {
          country: "India",
          company: "Kapil technologies Pvt Ltd",
          altercompany: "( KCS Software Solutions Pvt Ltd )",
          address: `Kapil Kavuri Hub, Nanakramguda, Gachibowli, Hyderabad`,
          pincode: "Telangana - 500032",
          email: "info@kapiltech.com",
        },
        {
          country: "Singapore",
          company: "Kapil Technologies Pte Ltd",
          address: `#13-01, 105 Cecil Street,`,
          pincode: "The Octagon - 069534",
          email: "info@kapiltech.com",
        },
        {
          country: "Thailand",
          company: "c/o Business Systemation Solution",
          address: `7/3 Moo. 7 Bangna Trad Rd., Bangchalong, Bangplee,`,
          pincode: "Samutprakarn - 105040",
          email: "info@kcs-tech.com",
        },
        {
          country: "Sri Lanka",
          company: "c/o Kraey Globe Limited",
          address: `39/10, Rampart Road, Ethul Kotte,`,
          pincode: "Kotte - 10100",
          email: "info@kcs-tech.com",
        },
        {
          country: "Fiji",
          company: "c/o Alpha Technologies",
          address: `58 Vomo Street, Lautoka,`,
          pincode: "Fiji Islands - 00000",
          email: "info@kcs-tech.com",
        },
        
    
        {
          country: "Malaysia",
          company: "Relevant Business Solutions SDN. BHD.",
          address: `Unit A805,No.1,Lorong Ultra B,
    
    Off Jalan Utara,
    
    46200 Petaling Jaya,`,
          pincode: "Selangor - 528225",
          email: "info@relevantsolution.com.my",
        },
        {
          country: "Combodia",
          company: "c/o Combodiasoft",
          address: `Building #101A, St. 289,
    
    Sangkat Boeung Kak I,
    
    Khan Toul Kok,`,
          pincode: "Phnom Penh - 120407",
          email: "info@kcs-tech.com",
        },
     
    
      ];
    
      const officeaddressesmiddleeast = [
        {
          country: "Egypt",
          company: "c/o Info Blendtec",
          address: `OP90 Business Complex, Office 339, Southern Teseen St., Zone 3`,
          pincode: "5th Settlement New Cairo- 11835 ",
          email: "info@kcs-tech.com",
        },
        
      ];
  return (
    <div>
      <section className="bg-[#f5f5f5]">
        <div className="xl:mx-40 mx-3 md:mx-6">
          <h2 className="text-4xl pb-8 pt-4 animate-up">Our Offices</h2>
          <ul className="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-b-[#d1d5db] dark:text-gray-400">
            <li
              onClick={() => handleNavLinkClick("america")}
              className={`cursor-pointer w-full sm:w-1/6 pt-3 pb-4 text-sm font-[500] text-[#0c0a09] ${
                activeLink === "america"
                  ? "border-x border-x-[#d1d5db] border-t border-t-[#d1d5db] text-orange-600"
                  : ""
              }`}
            >
              <div className="flex flex-col items-center">
                <span className="text-2xl mb-3">America</span>
                <img className="hidden sm:block" src={america} alt="america" />
              </div>
            </li>
            <li
              onClick={() => handleNavLinkClick("asiapacific")}
              className={`cursor-pointer w-full sm:w-1/6 pt-3 pb-4 text-sm font-[500] text-[#0c0a09] ${
                activeLink === "asiapacific"
                  ? "border-x border-x-[#d1d5db] border-t border-t-[#d1d5db] text-orange-600"
                  : ""
              }`}
            >
              <div className="flex flex-col items-center">
                <span className="text-2xl mb-3">Asia Pacific</span>
                <img
                  className="hidden sm:block"
                  src={asia_pacific}
                  alt="asia_pacific"
                />
              </div>
            </li>
           
            <li
              onClick={() => handleNavLinkClick("middleeast")}
              className={`cursor-pointer w-full sm:w-1/6 pt-3 pb-4 text-sm font-[500] text-[#0c0a09] ${
                activeLink === "middleeast"
                  ? "border-x border-x-[#d1d5db] border-t border-t-[#d1d5db] text-orange-600"
                  : ""
              }`}
            >
              <div className="flex flex-col items-center justify-center">
                <span className="text-2xl mb-3">Middle East</span>
                <img
                  className="hidden sm:block"
                  src={middle_east}
                  alt="middle_east"
                />
              </div>
            </li>
          </ul>

          {/* Office Address Content Based on Active Link */}
          {activeLink === "america" && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-x-4 py-5">
              {officeaddressesamerica.map((address, index) => (
                <div key={index} className="col-span-1 mt-5 ">
                  <h3 className="text-2xl text-[#4d4d4f] font-semibold">
                    {address.country}
                  </h3>
                  <h4 className="font-normal text-lg text-bluecolor">
                    {address.company}
                  </h4>
                  <span className="text-sm text-[#9ca3af] block mb-1">
                    {address.address}
                  </span>
                  <span className="text-sm text-[#9ca3af] block">
                    {address.pincode}
                  </span>

                  <p className="flex gap-2 items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="size-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
                      />
                    </svg>
                 
                      <span className="text-sm hover:text-bluecolor">
                        {address.email}
                      </span>
                   
                  </p>
                </div>
              ))}
            </div>
          )}
          {activeLink === "asiapacific" && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-x-4 py-5">
              {officeaddressesasiapacific.map((address, index) => (
                <div key={index} className="col-span-1 mt-5 ">
                  <h3 className="text-2xl text-[#4d4d4f] font-semibold">
                    {address.country}
                  </h3>
                  <h4 className="font-normal text-lg text-bluecolor">
                    {address.company}
                  </h4>
                  <h6 className="text-xs text-[#9ca3af] mb-1">
                    {address.altercompany}
                  </h6>
                  <span className="text-sm text-[#9ca3af] block mb-1">
                    {address.address}
                  </span>
                  <span className="text-sm text-[#9ca3af] block">
                    {address.pincode}
                  </span>

                  <p className="flex gap-2 items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="size-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
                      />
                    </svg>
                 
                      <span className="text-sm hover:text-bluecolor">
                        {address.email}
                      </span>
                    
                  </p>
                </div>
              ))}
            </div>
          )}

          {activeLink === "middleeast" && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-x-4 py-5">
              {officeaddressesmiddleeast.map((address, index) => (
              <div key={index} className="col-span-1 mt-5 ">
              <h3 className="text-2xl text-[#4d4d4f] font-semibold">
                {address.country}
              </h3>
              <h4 className="font-normal text-lg text-bluecolor">
                {address.company}
              </h4>
              <h6 className="text-xs text-[#9ca3af] mb-1">
                {address.altercompany}
              </h6>
              <span className="text-sm text-[#9ca3af] block mb-1">
                {address.address}
              </span>
              <span className="text-sm text-[#9ca3af] block">
                {address.pincode}
              </span>

              <p className="flex gap-2 items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="size-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
                  />
                </svg>
             
                  <span className="text-sm hover:text-bluecolor">
                    {address.email}
                  </span>
                
              </p>
            </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  )
}

export default ListOfAdresses
